import { ActionTypes as types, defaultCardSpec } from '../constants'
import serverProps from '../utils/serverProps'

function getInitialState(state = serverProps) {
  const { cardSpecs = {} } = state
  const initialState = {
    cardSpecs,
    cardSpec: defaultCardSpec, // the card spec based on the card number
    cardNumber: '',
    expiry: '',
    securityCode: '',
    addedCards: [],
    cardWasAdded: false,
  }
  return initialState
}

export default (state = getInitialState(), action) => {
  switch (action.type) {
    case types.EXTERNAL.RECEIVED_DATA:
      return {
        ...state,
        ...getInitialState(action.data),
      }

    case types.TRANSACTION.RECEIVED_SPECS:
      return {
        ...state,
        cardSpecs: action.data.cardSpecs,
      }

    case types.TRANSACTION.SUCCESS_FB_ADD_CARD:
      return {
        ...state,
        cardWasAdded: true,
      }

    default:
      return state
  }
}
